import styled from 'styled-components';

const ProductsHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: solid 2px #000000;
  padding: 25px 0 19px;
`;

const HeadingWrapper = styled.h1`
  flex: 1;
  height: 30px;
  margin-top: 27px;
  margin-bottom: 0;
  background-color: #ffffff;
  color: #000000;
  font-size: 30px;
  font-weight: bold;
  font-family: 'Avenir Black', 'Arial Black', sans-serif;
  line-height: 30px;
  letter-spacing: 1px;
  text-transform: uppercase;
  user-select: none;
`;

const HeadingWrapperLink = styled.a`
  text-align: center;
  line-height: 40px;
  background-color: #ffffff;
  color: #000000;
  user-select: none;
  font-family: 'Avenir Black', 'Arial Black', sans-serif;
  font-size: 30px;
  letter-spacing: 1px;
  text-transform: uppercase;
`;

export { ProductsHeaderContainer, HeadingWrapper, HeadingWrapperLink };
